import type { Directive, DirectiveBinding } from 'vue'
import type { CmsShortcutAction } from '@nsftx/seven-client-retail-vue-sgp'
import { registerShortcutAction } from './shortcutsService'

interface ShortcutElement extends HTMLElement {
  unregisterShortcut?: () => void
}

const isLocalShortcut = (binding: DirectiveBinding<CmsShortcutAction | undefined>) => (
  binding.arg === 'local' || Boolean(binding.modifiers.local)
)

const bindShortcutAction = (
  el: ShortcutElement,
  action: CmsShortcutAction | undefined,
  local: boolean,
) => {
  el.unregisterShortcut?.()
  el.unregisterShortcut = action
    ? registerShortcutAction(action, () => el.click(), local)
    : undefined
}

export const vShortcut: Directive<ShortcutElement, CmsShortcutAction | undefined, 'local', 'local'> = {
  mounted(el, binding) {
    bindShortcutAction(el, binding.value, isLocalShortcut(binding))
  },
  updated(el, binding) {
    if (binding.value === binding.oldValue) {
      return
    }

    bindShortcutAction(el, binding.value, isLocalShortcut(binding))
  },
  unmounted(el) {
    el.unregisterShortcut?.()
    delete el.unregisterShortcut
  },
}
